export const DiccionarioCajas_EN = [
    {
        'codigo': 'ErrorActualizarBecado',
        'mensaje': "There were problems updating the student's scholarship data."
    },
    {
        'codigo': 'ErrorActualizarCajBeca',
        'mensaje': 'There were problems updating the scholarship data.'
    },
    {
        'codigo': 'ErrorActualizarCajBecado',
        'mensaje': "There were problems updating the student's scholarship data."
    },
    {
        'codigo': 'ErrorActualizarCajBecaSedes',
        'mensaje': 'Problems arose when updating the campus of the scholarships.'
    },
    {
        'codigo': 'ErrorActualizarCajConcepto',
        'mensaje': 'There were problems updating the transaction data.'
    },
    {
        'codigo': 'ErrorActualizarCajConceptoMatricula',
        'mensaje': 'There were problems updating the currencies and transaction costs.'
    },
    {
        'codigo': 'ErrorActualizarCajImpuesto',
        'mensaje': 'There were problems updating the tax data.'
    },
    {
        'codigo': 'ErrorActualizarConcepto',
        'mensaje': 'There were problems updating the transaction data.'
    },
    {
        'codigo': 'ErrorActualizarConceptoImpuesto',
        'mensaje': 'There were problems updating the transaction taxes.'
    },
    {
        'codigo': 'ErrorActualizarConceptoMoneda',
        'mensaje': 'There were problems updating the currencies and transaction costs.'
    },
    {
        'codigo': 'ErrorActualizarFacturaPendiente',
        'mensaje': 'There were problems updating billing information.'
    },
    {
        'codigo': 'ErrorActualizarPayMethod',
        'mensaje': 'There were problems updating the payment method data.'
    },
    {
        'codigo': 'ErrorActualizarProforma',
        'mensaje': 'There were problems updating the proforma invoice.'
    },
    {
        'codigo': 'ErrorActualizarTransaccionImpuesto',
        'mensaje': 'There were problems updating the transaction taxes.'
    },
    {
        'codigo': 'ErrorAgregarExoneracion',
        'mensaje': 'There were problems adding the payment exception data.'
    },
    {
        'codigo': 'ErrorAgregarExoneracionBD',
        'mensaje': 'There were problems adding the payment exception data.'
    },
    {
        'codigo': 'ErrorAmountNotEmty',
        'mensaje': 'You must enter an amount.'
    },
    {
        'codigo': 'ErrorAnularFactura',
        'mensaje': 'There were problems canceling the billing.'
    },
    {
        'codigo': 'ErrorBecadoObtenerBecaporId',
        'mensaje': 'Problems arose when obtaining scholarship data.'
    },
    {
        'codigo': 'ErrorCajBecadoListaBecaPorSede',
        'mensaje': 'Problems arose when obtaining the scholarship campus.'
    },
    {
        'codigo': 'ErrorCampusIdNotEmpty',
        'mensaje': 'You must select a campus.'
    },
    {
        'codigo': 'ErrorCampusIdNotEmty',
        'mensaje': 'You must select a campus.'
    },
    {
        'codigo': 'ErrorCampusNotEmty',
        'mensaje': 'You must select a campus.'
    },
    {
        'codigo': 'ErrorCargarFacturaPago',
        'mensaje': 'There were problems loading the billing information.'
    },
    {
        'codigo': 'ErrorCashierIdNotEmpty',
        'mensaje': 'You must select the cashier.'
    },
    {
        'codigo': 'ErrorCashRegisterIdNotEmpty',
        'mensaje': 'Billing information not found.'
    },
    {
        'codigo': 'ErrorCerrarCaja',
        'mensaje': 'There were problems when closing billing.'
    },
    {
        'codigo': 'ErrorCerrarCajaBD',
        'mensaje': 'There were problems when closing billing.'
    },
    {
        'codigo': 'ErrorClosingDateNotEmpty',
        'mensaje': 'You must select a closing date.'
    },
    {
        'codigo': 'ErrorCodeNotEmty',
        'mensaje': 'The code is required.'
    },
    {
        'codigo': 'ErrorCompanyIdNotEmty',
        'mensaje': 'No company details found.'
    },
    {
        'codigo': 'ErrorCuadreCajero',
        'mensaje': 'There were problems registering the billing balance.'
    },
    {
        'codigo': 'ErrorCuadreCajeroBD',
        'mensaje': 'There were problems registering the billing balance.'
    },
    {
        'codigo': 'ErrorCurrencyIdNotEmty',
        'mensaje': 'You must select a currency.'
    },
    {
        'codigo': 'ErrorCustomerNotEmty',
        'mensaje': 'You must select a customer.'
    },
    {
        'codigo': 'ErrorDeleteBeca',
        'mensaje': 'Problems arose when the scholarship was eliminated.'
    },
    {
        'codigo': 'ErrorDeleteCajCashier',
        'mensaje': 'SThere were problems removing the cashier.'
    },
    {
        'codigo': 'ErrorDeleteCajProforms',
        'mensaje': 'There were problems deleting the temporary invoice.'
    },
    {
        'codigo': 'ErrorDeleteFacturaDetalle',
        'mensaje': 'There were problems removing the invoice detail.'
    },
    {
        'codigo': 'ErrorDeletePayMethod',
        'mensaje': 'There were problems removing the payment method.'
    },
    {
        'codigo': 'ErrorDscNotEmty',
        'mensaje': 'You must enter a description.'
    },
    {
        'codigo': 'ErrorEliminarBeca',
        'mensaje': 'Problems arose when the scholarship was eliminated.'
    },
    {
        'codigo': 'ErrorEliminarCajBeca',
        'mensaje': 'Problems arose when the scholarship was eliminated.'
    },
    {
        'codigo': 'ErrorEliminarCajBecado',
        'mensaje': "Problems arose when removing the student's scholarship."
    },
    {
        'codigo': 'ErrorEliminarCajConceptoMatricula',
        'mensaje': 'There were problems removing transaction costs.'
    },
    {
        'codigo': 'ErrorEliminarCajConceptos',
        'mensaje': 'There were problems deleting the transaction.'
    },
    {
        'codigo': 'ErrorEliminarConcepto',
        'mensaje': 'There were problems deleting the transaction.'
    },
    {
        'codigo': 'ErrorEliminarConceptoMoneda',
        'mensaje': 'There were problems removing transaction costs.'
    },
    {
        'codigo': 'ErrorEliminarExoneracion',
        'mensaje': 'There were problems removing the payment exception.'
    },
    {
        'codigo': 'ErrorEliminarExoneracionBD',
        'mensaje': 'There were problems removing the payment exception.'
    },
    {
        'codigo': 'ErrorEliminarFacturaPagoDetalle',
        'mensaje': 'There were problems removing the payment detail.'
    },
    {
        'codigo': 'ErrorEliminarImpuesto',
        'mensaje': 'Problems arose when the tax was eliminated.'
    },
    {
        'codigo': 'ErrorEliminarPayMethod',
        'mensaje': 'There were problems removing the payment method.'
    },
    {
        'codigo': 'ErrorEliminarProforma',
        'mensaje': 'There were problems deleting the temporary invoice.'
    },
    {
        'codigo': 'ErrorEmailNotEmty',
        'mensaje': 'You must enter an email.'
    },
    {
        'codigo': 'ErrorExceptionIdNotEmpty',
        'mensaje': 'The data of the exoneration of payment was not found.'
    },
    {
        'codigo': 'ErrorExistsCajCashier',
        'mensaje': 'A cashier already exists for the selected user.'
    },
    {
        'codigo': 'ErrorExistsConceptoCode',
        'mensaje': 'There is already a transaction with the entered code.'
    },
    {
        'codigo': 'ErrorExpirationNotEmty',
        'mensaje': 'You must enter the expiration date.'
    },
    {
        'codigo': 'ErrorFacturasPendientesExon',
        'mensaje': 'There were problems getting pending billing.'
    },
    {
        'codigo': 'ErrorFechaCierreCaja',
        'mensaje': 'You must enter the date for the billing closing process.'
    },
    {
        'codigo': 'ErrorGenerarFactura',
        'mensaje': 'There were problems generating billing data.'
    },
    {
        'codigo': 'ErrorIdeNotEmty',
        'mensaje': 'You must enter the identification number.'
    },
    {
        'codigo': 'ErrorIdNotEmpty',
        'mensaje': 'There were problems obtaining the data to perform the requested action.'
    },
    {
        'codigo': 'ErrorInsertarBecado',
        'mensaje': "There were problems when registering the data of the student's scholarship."
    },
    {
        'codigo': 'ErrorInsertarConcepto',
        'mensaje': 'There were problems recording the transaction.'
    },
    {
        'codigo': 'ErrorInsertarConceptoMoneda',
        'mensaje': 'There were problems recording transaction costs.'
    },
    {
        'codigo': 'ErrorInsertarFacturaConcepto',
        'mensaje': 'There were problems posting the transaction to billing.'
    },
    {
        'codigo': 'ErrorInsertarFacturaCuota',
        'mensaje': 'There were problems when registering the monthly financing.'
    },
    {
        'codigo': 'ErrorInsertarImpuesto',
        'mensaje': 'There were problems registering the tax.'
    },
    {
        'codigo': 'ErrorInsertarProforma',
        'mensaje': 'There were problems posting the temporary invoice.'
    },
    {
        'codigo': 'ErrorInsertCajBeca',
        'mensaje': 'There were problems registering the scholarship.'
    },
    {
        'codigo': 'ErrorInsertCajBecado',
        'mensaje': "There were problems when registering the data of the student's scholarship."
    },
    {
        'codigo': 'ErrorInsertCajCashier',
        'mensaje': 'There were problems when registering the cashier data.'
    },
    {
        'codigo': 'ErrorInsertCajConceptoMoneda',
        'mensaje': 'There were problems recording transaction costs.'
    },
    {
        'codigo': 'ErrorInsertCajConceptos',
        'mensaje': 'There were problems recording the transaction.'
    },
    {
        'codigo': 'ErrorInsertCajImpuesto',
        'mensaje': 'There were problems registering the tax.'
    },
    {
        'codigo': 'ErrorInsertCajProforms',
        'mensaje': 'There were problems posting the temporary invoice.'
    },
    {
        'codigo': 'ErrorInsertCashier',
        'mensaje': 'There were problems when registering the cashier data.'
    },
    {
        'codigo': 'ErrorInsertFacturaPago',
        'mensaje': 'There were problems when registering the billing payment data.'
    },
    {
        'codigo': 'ErrorInsertPayMethod',
        'mensaje': 'There were problems registering the payment method.'
    },
    {
        'codigo': 'ErrorInvoiceIdNotEmpty',
        'mensaje': 'Billing information not found.'
    },
    {
        'codigo': 'ErrorInvoiceIdNotEmty',
        'mensaje': 'Billing information not found.'
    },
    {
        'codigo': 'ErrorLimpiarFactura',
        'mensaje': 'There were problems cleaning the billing.'
    },
    {
        'codigo': 'ErrorListadoCajas',
        'mensaje': 'There were problems getting billing records.'
    },
    {
        'codigo': 'ErrorListadoRegistroExon',
        'mensaje': 'Problems arose when obtaining payment exception records.'
    },
    {
        'codigo': 'ErrorListarFacturaFormaPago',
        'mensaje': 'There were problems obtaining the billing payment methods.'
    },
    {
        'codigo': 'ErrorListCajBeca',
        'mensaje': 'Problems arose in obtaining scholarship records.'
    },
    {
        'codigo': 'ErrorListCajBecado',
        'mensaje': 'Problems arose in obtaining scholarship records.'
    },
    {
        'codigo': 'ErrorListCajBecadoListaBecaAsig',
        'mensaje': 'Problems arose in obtaining scholarship records.'
    },
    {
        'codigo': 'ErrorListCajBecaSedes',
        'mensaje': 'Problems arose when obtaining scholarship campus.'
    },
    {
        'codigo': 'ErrorListCajConceptoMoneda',
        'mensaje': 'Problems arose in obtaining transaction costs.'
    },
    {
        'codigo': 'ErrorListCajConceptos',
        'mensaje': 'There were problems getting transaction records.'
    },
    {
        'codigo': 'ErrorListCajImpuestos',
        'mensaje': 'There were problems obtaining tax records.'
    },
    {
        'codigo': 'ErrorListCajProforms',
        'mensaje': 'There were problems getting temporary invoice records.'
    },
    {
        'codigo': 'ErrorListFacturaConcepto',
        'mensaje': 'Problems arose when listing billing items.'
    },
    {
        'codigo': 'ErrorListFacturaCuota',
        'mensaje': 'Problems arose when listing the financing monthly installments.'
    },
    {
        'codigo': 'ErrorListFacturaCuotaFinanciamientos',
        'mensaje': 'Problems arose when listing the financing monthly installments.'
    },
    {
        'codigo': 'ErrorListFacturaDetalle',
        'mensaje': 'There were problems listing the billing records.'
    },
    {
        'codigo': 'ErrorListFacturaPendiente',
        'mensaje': 'There were problems listing pending billing records.'
    },
    {
        'codigo': 'ErrorListjCashier',
        'mensaje': 'There were problems getting the list of cashiers.'
    },
    {
        'codigo': 'ErrorListjPayMethods',
        'mensaje': 'There were problems getting the list of payment methods.'
    },
    {
        'codigo': 'ErrorListPayMethodCurrency',
        'mensaje': 'There were problems getting the list of payment methods.'
    },
    {
        'codigo': 'ErrorNameNotEmty',
        'mensaje': 'You must enter the name.'
    },
    {
        'codigo': 'ErrorObtenerBecado',
        'mensaje': "There were problems obtaining the student's scholarship data."
    },
    {
        'codigo': 'ErrorObtenerFactura',
        'mensaje': 'There were problems obtaining the billing data.'
    },
    {
        'codigo': 'ErrorObtenerIdCajBeca',
        'mensaje': 'Problems arose when obtaining scholarship data.'
    },
    {
        'codigo': 'ErrorObtenerIdCajBecado',
        'mensaje': "There were problems obtaining the student's scholarship data."
    },
    {
        'codigo': 'ErrorObtenerIdProformaFactura',
        'mensaje': 'There were problems obtaining the temporary invoice data.'
    },
    {
        'codigo': 'ErrorPagarFacturaPago',
        'mensaje': 'There were problems when making the payment of the invoice.'
    },
    {
        'codigo': 'ErrorPaymentMethodIdNotEmty',
        'mensaje': 'There were problems obtaining the payment method data.'
    },
    {
        'codigo': 'ErrorPayMethodIdNotEmpty',
        'mensaje': 'There were problems obtaining the payment method data.'
    },
    {
        'codigo': 'ErrorPctInscriptionNotEmty',
        'mensaje': 'You must enter a scholarship percentage for inscription.'
    },
    {
        'codigo': 'ErrorPctTuitionNotEmty',
        'mensaje': 'You must enter a scholarship percentage for tuition.'
    },
    {
        'codigo': 'ErrorPctBecaNotEmty',
        'mensaje': 'You must enter at least a scholarship percentage (Inscription or Tuition).'
    },
    {
        'codigo': 'ErrorPctNotEmty',
        'mensaje': 'You must enter the tax percentage.'
    },
    {
        'codigo': 'ErrorPendingInvoiceIdNotEmpty',
        'mensaje': 'There were problems obtaining pending billing data.'
    },
    {
        'codigo': 'ErrorProformIdNotEmpty',
        'mensaje': 'There were problems obtaining the data from the proforma invoice.'
    },
    {
        'codigo': 'ErrorRegistrosCajas',
        'mensaje': 'Se presentaron problemas al obtener los registros de facturación.'
    },
    {
        'codigo': 'ErrorSaveBeca',
        'mensaje': 'There were problems saving the scholarship.'
    },
    {
        'codigo': 'ErrorScholarShipIdNotEmpty',
        'mensaje': 'Problems arose when obtaining scholarship data.'
    },
    {
        'codigo': 'ErrorScholarShipNotEmty',
        'mensaje': 'Problems arose when obtaining scholarship data.'
    },
    {
        'codigo': 'ErrorTaxIdNotEmpty',
        'mensaje': 'There were problems obtaining the tax data.'
    },
    {
        'codigo': 'ErrorTransactionIdNotEmpty',
        'mensaje': 'There were problems getting the transaction data.'
    },
    {
        'codigo': 'ErrorTransactionIdNotEmty',
        'mensaje': 'There were problems getting the transaction data.'
    },
    {
        'codigo': 'ErrorTypeIdeNotEmty',
        'mensaje': 'You must select an identification type.'
    },
    {
        'codigo': 'ErrorUpdateBeca',
        'mensaje': 'There were problems updating the scholarship.'
    },
    {
        'codigo': 'ErrorUpdateCajCashier',
        'mensaje': 'There were problems updating the cashier data.'
    },
    {
        'codigo': 'ErrorUpdateCajPayMethod',
        'mensaje': 'There were problems updating the payment method.'
    },
    {
        'codigo': 'ErrorUpdateCajProforms',
        'mensaje': 'There were problems updating the proforma invoice.'
    },
    {
        'codigo': 'ErrorUpdateFacturaConcepto',
        'mensaje': 'There were problems updating the billing transaction.'
    },
    {
        'codigo': 'ErrorUpdateFacturaPendiente',
        'mensaje': 'There were problems updating the pending invoice.'
    },
    {
        'codigo': 'ErrorUpdateSedes',
        'mensaje': 'There were problems updating the campus.'
    },
    {
        'codigo': 'ErrorUserIdNotEmty',
        'mensaje': 'You must select a user.'
    },
    {
        'codigo': 'ErrorUsuarioIdNotEmty',
        'mensaje': 'You must select a user.'
    },
    {
        'codigo': 'ErrorValidarCajeroBD',
        'mensaje': "Problems arose when validating the cashier's data."
    },
    {
        'codigo': 'ErrorValidarDetalleFacturaPago',
        'mensaje': 'There were problems validating the payment details.'
    },
    {
        'codigo': 'ErrorValidarFacturaPago',
        'mensaje': 'There were problems validating the payment of the invoice.'
    },
    {
        'codigo': 'ErrorValidarPagoFacturaPago',
        'mensaje': 'There were problems validating the payment of the invoice.'
    },
    {
        'codigo': 'ErrorValidatingCode',
        'mensaje': 'There were problems validating the entered code.'
    },
    {
        'codigo': 'ErrorListConceptosGestiones',
        'mensaje': 'There were problems getting the list of transactions.'
    },
    {
        'codigo': 'ErrorRegenerarFactura',
        'mensaje': 'There were problems processing billing records.'
    },
    {
        'codigo': 'ErrorActualizaFinanciamiento',
        'mensaje': 'There were problems updating the financing.'
    },
    {
        'codigo': 'ErrorListaItemPendiente',
        'mensaje': 'There were problems getting pending billing.'
    },
    {
        'codigo': 'FormartFileError',
        'mensaje': 'File format (extension) not allowed.'
    },
    {
        'codigo': 'CodeRequeridoReference',
        'mensaje': 'The reference is required.'
    },
    {
        'codigo': 'CodeRequeridoDetail',
        'mensaje': 'You must indicate the payment details.'
    },
    {
        'codigo': 'SearchOneFilterReq',
        'mensaje': 'You must enter at least one search filter.'
    },
    {
        'codigo': 'ErrorPayAmount',
        'mensaje': 'The amount received is less than the amount to be paid.'
    },
    {
        'codigo': 'CodeRequeridoScholarShipId',
        'mensaje': 'The type of scholarship is required.'
    },
    {
        'codigo': 'CodeRequeridoPctInscription',
        'mensaje': 'The scholarship percentage is required.'
    },
    {
        'codigo': 'CodeRequeridoPctTuition',
        'mensaje': 'The scholarship percentage is required.'
    },
    {
        'codigo': 'CodeRequeridoAmount',
        'mensaje': 'The amount is required.'
    },
    {
        'codigo': 'CodeRequeridoCurrencyId',
        'mensaje': 'The currency is required.'
    },
    {
        'codigo': 'CodeRequeridoInvoiceId',
        'mensaje': 'Billing information not found.'
    },
    {
        'codigo': 'CodeRequeridoCampusId',
        'mensaje': 'The campus is required.'
    },
    {
        'codigo': 'CodeRequeridoComentario',
        'mensaje': 'You must enter a comment.'
    },
    {
        'codigo': 'CodeRequeridoExectionId',
        'mensaje': 'The data of the exoneration of payment was not found.'
    },
    {
        'codigo': 'CodeRequeridoProcesoId',
        'mensaje': 'You must select a section from the list.'
    },
    {
        'codigo': 'CodeRequeridoScholarShipId',
        'mensaje': 'The selected discount is not found.'
    },
    {
        'codigo': 'CodeRequeridoPeriodDetailId',
        'mensaje': 'The selected period is not found.'
    },
    {
        'codigo': 'CodeRequeridoPeriodTypeId',
        'mensaje': 'The selected period type is not found.'
    },
    {
        'codigo': 'ErrorUpdateFacturaCuotaSequence',
        'mensaje': 'Financing monthly installments must be added in ascending order.'
    },
    {
        'codigo': 'ErrorDeleteFacturaCuotaSequence',
        'mensaje': 'Financing monthly installments must be removed in descending order.'
    },
    {
        'codigo': 'ErrorUpdateFacturaCuota',
        'mensaje': 'There were problems when registering the monthly financing payments.'
    },
    {
        'codigo': 'AmountHigherNoteFinan',
        'mensaje': 'When making the financing payment, the pending amount is exceeded.'
    },
    {
        'codigo': 'ErrorFinanInsertNote',
        'mensaje': 'There were problems applying the financing notes for invoicing.'
    },
];

